module.exports = __webpack_public_path__ + "static/image12-45ba4351814d4c3f936ed54fffa440d8.jpg";